import { TitleOfferFragment, TitleOfferLightFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { type PlayerModalTitle } from '@/features/title-player/types';
import { WatchNowOfferFragment } from '@/pages/graphql/fragments/WatchNowOffer.fragment';
import { JWTV_PROVIDER_CONFIG } from '@/features/jwtv/config';

const jwTVModal = () => import('@/features/jwtv-avod/components/JWTVAvodModal.vue');

type JwTVModalProps = {
	offer: WatchNowOfferFragment | TitleOfferFragment | TitleOfferLightFragment;
	title?: PlayerModalTitle;
	additionalContexts?: SnowplowContext[];
};

export async function openJwTvAvodModal(payload: { modalProps: JwTVModalProps; onClose?: () => void }) {
	await ModalHelper.openModal(
		jwTVModal,
		{
			...payload.modalProps,
		},
		{ cssClass: 'trailer-modal' },
		'',
		true,
		payload.modalProps.additionalContexts ?? [],
		() => {
			payload.onClose?.();
		}
	);
}

export function isJWTVAvodOffer(offer: TitleOfferFragment | WatchNowOfferFragment): boolean {
	const config = JWTV_PROVIDER_CONFIG.find(
		c => c.shortName === offer.package.shortName && c.monetizationTypes.includes(offer.monetizationType)
	);
	return !!config && config.type === 'AVOD';
}
